import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { run } from 'y4/layouts/content/Executer';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const RegistrationFormDataHelper = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('data-helper-register');
  // State
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    password: '',
    confirmPassword: '',
    authorization: ''
  });

  // Handler
  const handleSubmit = e => {
    e.preventDefault();

    run({
      command: 'PostToServlet',
      navigate: navigate,
      params: {
        servlet: 'Task',
        command: 'Run',
        javascript: '',
        params: formData,
        queries: {
          task: 'TASK_Register'
        }
      }
    }).then(() => {
      //console.log('kkkkkkk', rt);
    });

    /*
    y.toastSuccess(`Successfully registered as ${formData.name}`, {
      theme: 'colored'
    });
    */
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Control
          placeholder={t('Name')}
          value={formData.name}
          name="name"
          onChange={handleFieldChange}
          type="text"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Control
          placeholder={t('Phone')}
          value={formData.phone}
          name="phone"
          onChange={handleFieldChange}
          type="text"
        />
      </Form.Group>

      <Row className="g-2 mb-3">
        <Form.Group as={Col} sm={6}>
          <Form.Control
            placeholder={t('Password')}
            value={formData.password}
            name="password"
            onChange={handleFieldChange}
            type="password"
          />
        </Form.Group>
        <Form.Group as={Col} sm={6}>
          <Form.Control
            placeholder={t('Confirm password')}
            value={formData.confirmPassword}
            name="confirmPassword"
            onChange={handleFieldChange}
            type="password"
          />
        </Form.Group>
      </Row>
      <Form.Group className="mb-3">
        <Form.Control
          placeholder={t('Authorization')}
          value={formData.authorization}
          name="authorization"
          onChange={handleFieldChange}
          rows={3}
          type="text"
          as="textarea"
        />
        <Form.Label>{t('Need to apply for an authorization code')}</Form.Label>
      </Form.Group>
      <Form.Group className="mb-4">
        <Button
          className="w-100"
          type="submit"
          disabled={
            !formData.name ||
            !formData.phone ||
            !formData.password ||
            !formData.confirmPassword ||
            !formData.authorization
          }
        >
          {t('Register')}
        </Button>
      </Form.Group>
    </Form>
  );
};

RegistrationFormDataHelper.propTypes = {
  hasLabel: PropTypes.bool
};

export default RegistrationFormDataHelper;
